import { getStoredSessionToken } from '../../app/services/session.service';

async function request(path = '', { signal, method = 'GET' } = {}) {
  const token = getStoredSessionToken();
  const response = await fetch(`/api/notifications${path}`, {
    method, signal, cache: 'no-store',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) throw new Error('Impossibile aggiornare le notifiche. Riprova.');
  return response.status === 204 ? null : response.json();
}

export async function listNotifications(beforeId, signal) {
  const result = await request(beforeId ? `?beforeId=${encodeURIComponent(beforeId)}` : '', { signal });
  if (!Array.isArray(result?.items) || !Number.isFinite(result.unreadCount)) throw new Error('Impossibile caricare le notifiche. Riprova.');
  return result;
}
export const readNotification = (id) => request(`/${encodeURIComponent(id)}/read`, { method: 'POST' });
export const readAllNotifications = (throughId) => request(`/read-all?throughId=${encodeURIComponent(throughId)}`, { method: 'POST' });
